export default 'PAN-29215';
